import Inventory from './Inventory';
import Adjustment from './Adjustment';
import PurchaseOrder from './PurchaseOrder';
import Summary from './Summary';
import Transfer from './Transfer';
import Supplier from './Supplier';

export { Adjustment, PurchaseOrder, Summary, Transfer, Supplier };
export default Inventory;
